const INFO = {
	main: {
		title: "SCHOINAS CONSULTING",
		name: "Konstantinos Schoinas",
		email: "knschoinas@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/sxoinas12",
		linkedin: "https://www.linkedin.com/in/konstantinosschoinas/",
		stackoverflow: "https://stackoverflow.com/users/11716791/konstanitnos-schoinas",
	},

	homepage: {
		title: "SCHOINAS CONSULTING ΜΟΝΟΠΡΟΣΩΠΗ Ι.Κ.Ε",
		description:
			"Η εταιρεία 'SCHOINAS CONSULTING' προσφέρει εξειδικευμένες υπηρεσίες στον τομέα της τεχνολογίας πληροφορικής, περιλαμβάνοντας τη σχεδίαση και ανάπτυξη τεχνολογιών πληροφορίας, τη δημιουργία ιστοσελίδων στο διαδίκτυο, καθώς και την παροχή εξειδικευμένων συμβουλών σε θέματα μάρκετινγκ. Με επικέντρωση στον σχεδιασμό, την υποστήριξη και την ολοκλήρωση συστημάτων λογισμικού, η εταιρεία μας προσφέρει εξειδικευμένες λύσεις που ανταποκρίνονται στις ανάγκες των πελατών μας.",
	},

	about: {
		title: "I’m Tharindu N. I live in Sri Lanka, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Project 1",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 2",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 3",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 4",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Project 5",
			description:
				"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};

export default INFO;
